<div class="downtime-modal">
  <!-- Header -->
  <div class="downtime-modal__header">
    <div class="downtime-modal__header-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#e65100" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
    </div>
    <h2 class="downtime-modal__title">Scheduled Maintenance</h2>
    <div class="downtime-modal__close" (click)="close()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>

  <!-- Subtitle -->
  <p class="downtime-modal__subtitle">Dear Merchants &amp; Owners</p>

  <p class="downtime-modal__desc">
    Please be informed of the system downtime for maintenance on the following days:
  </p>

  <div class="downtime-modal__time-block">
    <div class="downtime-modal__time-row">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#1742ff"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
      <span class="downtime-modal__time-text">12 May: 2:00 AM – 3:00 AM (1 hour)</span>
    </div>
    <div class="downtime-modal__time-row">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#1742ff"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
      <span class="downtime-modal__time-text">13 May: 1:00 AM – 3:30 AM (2 hours 30 minutes)</span>
    </div>
  </div>

  <!-- Description -->
  <p class="downtime-modal__desc">
    Our systems are undergoing scheduled maintenance to improve your experience. Some features will be unavailable during this window.
  </p>

  <!-- Affected services -->
  <div class="downtime-modal__affected">
    <h3 class="downtime-modal__affected-title">Affected during maintenance</h3>
    <ul class="downtime-modal__list">
      <li class="downtime-modal__list-item downtime-modal__list-item--unavailable">
        <span class="downtime-modal__status-dot downtime-modal__status-dot--red"></span>
        Online payments
      </li>
      <li class="downtime-modal__list-item downtime-modal__list-item--unavailable">
        <span class="downtime-modal__status-dot downtime-modal__status-dot--red"></span>
        New order placement
      </li>
      <li class="downtime-modal__list-item downtime-modal__list-item--unavailable">
        <span class="downtime-modal__status-dot downtime-modal__status-dot--red"></span>
        Viewing existing orders
      </li>
    </ul>
  </div>

  <!-- Footer note -->
  <div class="downtime-modal__footer">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4caf50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
      <polyline points="22 4 12 14.01 9 11.01"/>
    </svg>
    <span>Services will resume automatically after 3:30 AM. No action needed from your side.</span>
  </div>
</div>